import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import type { ProductListMenuItemViewModel } from 'autogen/swagger/all';
import { SeeAllIn } from 'autogen/translation-keys/trans-website-shared';
import DrawerView from 'components/generic/Drawer/DrawerView';
import useDrawer from 'components/generic/Drawer/hooks/useDrawer';
import Menu from 'components/generic/menu';
import Icon from 'components/Icon';
import ListItem from 'components/List/components/ListItem/ListItem';
import MenuHeader from 'components/sideMenu/components/Menu/components/MenuHeader';
import MenuItemsRenderer, { ItemRenderer } from './MenuItemsRenderer';

/* #region styles */
const StyledDrawerView = styled(DrawerView)`
    flex-direction: column;
`;

const StyledDefaultMenuSection = styled(Menu.SecondarySection)`
    background-color: ${ColorNeutralWhite};
    &:after {
        width: 100%;
    }

    &:empty {
        display: none;
    }
`;
/* #endregion */

const CategorySideSubMenu = ({ model }: { model: ProductListMenuItemViewModel }) => {
    const { children, itemElement } = model;
    const id = `${itemElement.text}-category-menu`;
    const { t } = useTranslation();
    const { open, close } = useDrawer(id);

    return (
        <>
            <ListItem.Button
                buttonProps={{ onClick: open }}
                AfterRenderer={() => <Icon type="ChevronRight" size={16} />}
            >
                {itemElement.text}
            </ListItem.Button>
            <StyledDrawerView id={id} animate={false} position="left">
                <MenuHeader headline={itemElement.text} backButtonCallback={close} styling="White" />
                <Menu>
                    <StyledDefaultMenuSection>
                        {/* create the see all menu item */}
                        <ItemRenderer
                            model={{
                                ...model,
                                itemElement: { ...model.itemElement, text: `${t(SeeAllIn)} ${model.itemElement.text}` }
                            }}
                        />

                        {/* render rest of menu items */}
                        <MenuItemsRenderer menuItems={children} />
                    </StyledDefaultMenuSection>
                </Menu>
            </StyledDrawerView>
        </>
    );
};

export default memo(CategorySideSubMenu);
